import { ColourPickerContext } from './ColourPickerContext';
import ColourSwatchGrid from './ColourSwatchGrid';
import ColourSwatch, {
  ColourSwatchCard,
  ColourSwatchPdp,
} from './ColourSwatch/index';

export type {
  ColourPickerColour,
  ColourPickerContextValue,
} from './ColourPickerContext';
export { useColourPickerContext } from './ColourPickerContext';

/**
 * Compound ColourPicker component. Use Provider to supply state/actions,
 * then compose Grid and/or Swatch as needed (e.g. for PDP or PLP).
 *
 * Grid renders explicit `ColourSwatchCard` vs `ColourSwatchPdp` from context
 * `variant`. `Swatch` is a thin dispatcher for ad-hoc composition.
 *
 * @example
 * <ColourPicker.Provider value={{ state: { colours }, actions: { onSelectColour } }}>
 *   <ColourPicker.Grid />
 * </ColourPicker.Provider>
 */
export const ColourPicker = {
  Provider: ColourPickerContext.Provider,
  Grid: ColourSwatchGrid,
  /** Dispatches to Card vs Pdp from context `variant`. */
  Swatch: ColourSwatch,
  SwatchCard: ColourSwatchCard,
  SwatchPdp: ColourSwatchPdp,
};
